export default {
  "content": "<path stroke=\"#D3D4D9\" stroke-linecap=\"square\" stroke-dasharray=\"12 12\" d=\"M.5.5h358M.5 46.5h358M.5 92.5h358M.5 138.5h358\"/><path stroke=\"#D3D4D9\" d=\"M0 185.5h359\"/><path d=\"M72 134h24v51H72zM120 61h24v124h-24zM168 118h24v67h-24zM216 10h24v175h-24zM264 170h24v15h-24zM312 78h24v107h-24zM24 18h24v167H24z\"/>",
  "attrs": {
    "width": "359",
    "height": "186",
    "viewBox": "0 0 359 186",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};